<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="10" lg="8">
        <v-card class="pa-4 elevation-2">
          <v-card-title class="headline mb-2">
            {{ t("message.aboutTitle") }}
          </v-card-title>
          <v-card-text>
            <v-divider class="mb-4"></v-divider>
            <v-row>
              <v-col cols="12" class="mb-3">
                <p class="left-align">{{ t("message.aboutDescription1") }}</p>
              </v-col>
              <v-col cols="12" class="mb-3">
                <p class="left-align">{{ t("message.aboutDescription2") }}</p>
              </v-col>
              <v-col cols="12" class="mb-2">
                <h3 class="section-title">{{ t("message.aboutDataTitle") }}</h3>
                <p class="left-align">{{ t("message.aboutDataDescription1") }}</p>
                <p class="left-align">{{ t("message.aboutDataDescription2") }}</p>
                <p class="attribution-label">
                  {{ t("message.aboutDataAttributionLabel") }}
                </p>
                <p class="attribution-quote">
                  {{ t("message.aboutDataAttributionQuote") }}
                </p>
                <ul class="left-align requirements-list">
                  <li>{{ t("message.aboutDataRequirement1") }}</li>
                  <li>{{ t("message.aboutDataRequirement2") }}</li>
                  <li>{{ t("message.aboutDataRequirement3") }}</li>
                </ul>
              </v-col>
              <v-col cols="12" class="mb-3">
                <h3 class="section-title">{{ t("message.aboutDataSourcesTitle") }}</h3>
                <div class="left-align source-links">
                  <a :href="links.dbhApiDocs" target="_blank" rel="noopener noreferrer">
                    {{ t("message.aboutLinkDbhDocs") }}
                  </a>
                  <a :href="links.apiDataset" target="_blank" rel="noopener noreferrer">
                    {{ t("message.aboutLinkDataset") }}
                  </a>
                  <a :href="links.nlod" target="_blank" rel="noopener noreferrer">
                    {{ t("message.aboutLinkNlod") }}
                  </a>
                </div>
                <p class="verified-note">
                  {{ t("message.aboutDataVerified", { date: licenseVerifiedDate }) }}
                </p>
              </v-col>
              <v-col cols="12" class="mb-1">
                <p class="left-align">
                  {{
                    contactEmail
                      ? t("message.aboutDescription3", { email: contactEmail })
                      : t("message.aboutDescription3NoEmail")
                  }}
                </p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { inject } from "vue";

const CONTACT_EMAIL = process.env.VUE_APP_CONTACT_EMAIL || "";
const LEGAL_LAST_UPDATED = (process.env.VUE_APP_LEGAL_LAST_UPDATED || "2026-02-11").trim();

const LINKS = {
  dbhApiDocs: "https://dbh.hkdir.no/static/files/dokumenter/api/api_dokumentasjon.pdf",
  apiDataset:
    "https://data.norge.no/nb/datasets/9efe2de1-1093-4662-a8cb-fd7907bae9bc/api-mot-hk-dir-sin-database-for-statistikk-om-hoyere-utdanning-dbh",
  nlod: "https://data.norge.no/nlod/no/2.0",
};

export default {
  name: "AboutPage",
  setup() {
    const state = inject("state");

    const t = (key, params = {}) => {
      const keys = key.split(".");
      let value = state.translations[state.locale];
      keys.forEach((k) => {
        value = value?.[k];
      });
      if (typeof value === "string") {
        return value.replace(/\{\{(\w+)\}\}/g, (_, paramKey) => {
          const paramValue = params[paramKey];
          return paramValue == null ? `{{${paramKey}}}` : String(paramValue);
        });
      }
      return value;
    };

    return {
      t,
      contactEmail: CONTACT_EMAIL,
      licenseVerifiedDate: LEGAL_LAST_UPDATED,
      links: LINKS,
    };
  },
};
</script>

<style scoped>
.v-card-title {
  font-weight: 600;
  font-size: 2rem;
  color: var(--og-text);
  font-family: "Newsreader", serif;
}

.v-card {
  background: var(--og-surface) !important;
  border: 1px solid var(--og-border);
  border-radius: 18px !important;
  box-shadow: var(--og-shadow) !important;
}

p {
  line-height: 1.6;
  color: var(--og-muted);
}

.left-align {
  text-align: left;
}

.v-divider {
  margin-bottom: 20px;
}

.section-title {
  text-align: left;
  color: var(--og-text);
  margin-bottom: 8px;
  font-family: "Newsreader", serif;
}

.attribution-label {
  text-align: left;
  font-weight: 600;
  margin-bottom: 4px;
  color: var(--og-text);
}

.attribution-quote {
  text-align: left;
  background: var(--og-surface-soft);
  border: 1px solid var(--og-border);
  border-radius: 8px;
  padding: 10px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
    "Courier New", monospace;
  margin-bottom: 10px;
  color: var(--og-text);
}

.requirements-list {
  margin-top: 0;
  padding-left: 20px;
}

.source-links {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.source-links a {
  color: var(--og-link);
  text-decoration: none;
}

.source-links a:hover {
  text-decoration: underline;
}

.verified-note {
  text-align: left;
  margin-top: 10px;
  color: var(--og-muted);
  font-size: 0.9rem;
}

@media (max-width: 600px) {
  .v-card-title {
    font-size: 1.5rem;
  }
  p {
    font-size: 0.9rem;
  }
}
</style>
